import { useState } from "react";

export const useFeedbackFilter = () => {
    const [FeedbackFilter, setFeedbackFilter] = useState({
        attribute: 'Sector', // Valid attributes: 'Sector', 'CompanyName', 'Category', 'ExperiencewithNCH', 'userexperience', 'unUnsatisfactory'
        Sector: 'All',
        CompanyName: 'All',
        Category: 'All',
        startDate: new Date("2025-01-01"),
        endDate: new Date(),
        skip: 0,
        limit: 1000
    });

    const handleFeedbackFilterChange = (name, value) => {
        setFeedbackFilter(prev => ({ ...prev, [name]: value }));
    };

    const updateFeedbackFilter = (newFilters) => {
        setFeedbackFilter(prev => ({ ...prev, ...newFilters }));
    };

    const resetFeedbackFilter = () => {
        setFeedbackFilter({
            attribute: 'Sector',
            Sector: 'All',
            CompanyName: 'All',
            Category: 'All',
            startDate: new Date("2025-01-01"),
            endDate: new Date(), // Today
            skip: 0,
            limit: 1000
        });
    };

    return {
        filters: FeedbackFilter,
        handleFeedbackFilterChange,
        updateFeedbackFilter,
        resetFeedbackFilter
    };

}